import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '@systemeio/components';
import { AffiliateDashboardStatisticInterface } from 'modules/affiliate-dashboard/types/affiliate-dashboard-statistic-interface';
import { AffiliateCard, AffiliateCardTitle, AffiliateCopyField, AffiliateStatRow } from 'modules/affiliate/components/affiliate-card';
import { Hint } from 'shared/components';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
interface AffiliateDashboardIdCardProps {
  affiliateStatistic?: AffiliateDashboardStatisticInterface;
}
export function AffiliateDashboardIdCard(t0) {
  const $ = _c(22);
  const {
    affiliateStatistic
  } = t0;
  const {
    t
  } = useLocoTranslation();
  let t1;
  if ($[0] !== t) {
    t1 = t("dashboard.affiliate_dashboard.your_affiliate_id");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t) {
    t2 = t("dashboard.affiliate_dashboard.affiliate_id_tooltip-new");
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <Hint label={t2} />;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t1 || $[7] !== t3) {
    t4 = <AffiliateCardTitle>{t1}{t3}</AffiliateCardTitle>;
    $[6] = t1;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const t5 = affiliateStatistic?.user.affiliateAccount.affiliateId;
  let t6;
  if ($[9] !== t5) {
    t6 = <AffiliateCopyField value={t5} />;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t) {
    t7 = t("dashboard.affiliate.total_leads");
    $[11] = t;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== affiliateStatistic?.totalLeads) {
    t8 = affiliateStatistic?.totalLeads ?? <Skeleton className="h-5 w-10" />;
    $[13] = affiliateStatistic?.totalLeads;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t7 || $[16] !== t8) {
    t9 = <dl><AffiliateStatRow label={t7}>{t8}</AffiliateStatRow></dl>;
    $[15] = t7;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t4 || $[19] !== t6 || $[20] !== t9) {
    t10 = <AffiliateCard>{t4}{t6}{t9}</AffiliateCard>;
    $[18] = t4;
    $[19] = t6;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  return t10;
}